export class numberHelper {
  static numbersToWords(value: number): string {
    const numbersToWordsArray = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];
    if (Number.isNaN(value)) {
      return '';
    }
    if (value > numbersToWordsArray.length - 1) {
      return value.toString();
    }
    return numbersToWordsArray[value];
  }
  static formatMoney(value: number): string {
    if (Number.isNaN(value)) {
      return '';
    }
    let formattedString: string = value.toFixed(2); // Format with two decimal places
    return `$${formattedString}`;
  }
}
